import { ArrowLeft } from 'lucide-react';
import DOMPurify from 'dompurify';
import { useKBArticle } from '@/hooks/useKnowledgeBase';

interface KBArticleViewProps {
  articleId: number;
  onBack: () => void;
}

export default function KBArticleView({ articleId, onBack }: KBArticleViewProps) {
  const { data: article, isLoading } = useKBArticle(articleId);

  if (isLoading) {
    return (
      <div className="space-y-3 py-2 animate-pulse">
        <div className="h-5 w-2/3 bg-base-300 rounded" />
        <div className="h-3 w-full bg-base-300 rounded" />
        <div className="h-3 w-5/6 bg-base-300 rounded" />
        <div className="h-3 w-4/6 bg-base-300 rounded" />
      </div>
    );
  }

  if (!article) {
    return (
      <div className="text-center py-8 text-sm text-base-content/50">
        Artikel nicht gefunden
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="btn btn-ghost btn-xs btn-circle"
          onClick={onBack}
        >
          <ArrowLeft className="h-3.5 w-3.5" />
        </button>
        <h3 className="text-sm font-semibold flex-1 truncate">{article.title}</h3>
      </div>

      {/* Content */}
      <div
        className="kb-article-content overflow-y-auto pr-1"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.content_html) }}
      />
    </div>
  );
}
